import Notes from '@/views/Notes/Index'
import NotesProductionSiteNotes from '@/views/Notes/ProductionSiteNotes/Index'
import NotesProductionSiteNotesProductionSiteNote from '@/views/Notes/ProductionSiteNotes/ProductionSiteNote'

export default [
    {
        path: '/notes',
        name: 'notes',
        component: Notes,
        meta: {
            title: 'Notki stanowiskowe',
            menuRendered: true,
            menuTitle: 'Notki stanowiskowe',
            requiresAuth: true,
            permission: ['production_sites_notes_admin_read', 'production_sites_note_leader_read'],
            icon: 'mdi-clipboard-text-outline',
            badge: {
                name: 'userProductionSiteNoteCount',
                count: null
            }
        },
        redirect: { name: 'notesProductionSiteNotes' },
        children: [
            {
                path: '/notes/production-site-notes',
                name: 'notesProductionSiteNotes',
                component: NotesProductionSiteNotes,
                meta: {
                    title: 'Notki stanowiskowe',
                    menuTitle: 'Notki stanowiskowe',
                    permission: ['production_sites_notes_admin', 'production_sites_note_leader'],
                    requiresAuth: true,
                },
            },
            {
                path: '/notes/production-site-notes/create',
                name: 'notesProductionSiteNoteCreate',
                component: NotesProductionSiteNotesProductionSiteNote,
                meta: {
                    title: 'Notki stanowiskowe / Nowa notka',
                    permission: ['production_sites_notes_admin_create', 'production_sites_note_leader_create'],
                    requiresAuth: true,
                },
            },
            {
                path: '/notes/production-site-notes/edit/:id',
                name: 'notesProductionSiteNoteEdit',
                component: NotesProductionSiteNotesProductionSiteNote,
                meta: {
                    title: 'Notki stanowiskowe / Edycja notki',
                    permission: ['production_sites_notes_admin_update', 'production_sites_note_leader_update'],
                    requiresAuth: true,
                },
            },
        ],
    },
]
